"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ServerSideRenderedContent;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styles = require("@material-ui/core/styles");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _ui = require("../../ui");

var _util = require("../../util");

var _excluded = ["theme", "html", "RenderingComponent"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ServerSideRenderedContent(props) {
  var ssrContainerNode = (0, _react.useRef)(null);
  var theme = props.theme,
      html = props.html,
      RenderingComponent = props.RenderingComponent,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var jbrowseTheme = (0, _ui.createJBrowseTheme)(theme);
  (0, _react.useEffect)(function () {
    var domNode = ssrContainerNode.current;

    function doHydrate() {
      if (domNode) {
        if (domNode) {
          (0, _reactDom.unmountComponentAtNode)(domNode);
        }

        domNode.innerHTML = html; // defer main-thread rendering and hydration for when
        // we have some free time. helps keep the framerate up.
        //
        // note: the timeout param to rIC below helps when you are doing
        // a long continuous scroll, it forces it to evaluate because
        // otherwise the continuous scroll would never give it time to do
        // so

        (0, _util.rIC)(function () {
          (0, _reactDom.hydrate)( /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
            theme: jbrowseTheme
          }, /*#__PURE__*/_react.default.createElement(RenderingComponent, rest)), domNode);
        }, {
          timeout: 300
        });
      }
    }

    doHydrate();
    return function () {
      if (domNode) {
        (0, _reactDom.unmountComponentAtNode)(domNode);
      }
    };
  }, [html, jbrowseTheme, rest, RenderingComponent]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ssrContainerNode,
    "data-html-size": html.length,
    className: "ssr-container"
  });
}